<section class="l-flex l-column l-deashboard--gallery">
    <button class="save_patieont" (click)="assign()" *ngIf="inbox" style="margin-top: -2em;">
        Assign To this Exam
    </button>
    <ul class="t-menu" style="justify-content: space-between;">
        <div style="display: inline-flex;">
        <li *ngIf="! forPrint && ! gs.showSelect">
            <button class="t-menu-item" [ngClass]="show == 'all' ? 'is-active' : ''" (click)="show = 'all'">
                All ({{imgct+clipct}})
            </button>
        </li>
        <li *ngIf="view !='Timeline'">
            <button class="t-menu-item" [ngClass]="show == 'img' ? 'is-active' : ''" (click)="show = 'img'">
                Images ({{imgct}})
            </button>
        </li>
        <li *ngIf="! forPrint && ! gs.showSelect && view !='Timeline'">
            <button class="t-menu-item" [ngClass]="show == 'clip' ? 'is-active' : ''" (click)="show = 'clip'">
                Clips ({{clipct}})
            </button>
        </li>
        <li *ngIf="! forPrint && ! gs.showSelect && view !='Timeline'">
            <button class="t-menu-item" [ngClass]="show == 'pdf' ? 'is-active' : ''" (click)="show = 'pdf'">
                PDFs ({{pdfct}})
            </button>
        </li>
        <li *ngIf="! forPrint && ! gs.showSelect && view !='Timeline'">
            <button class="t-menu-item" (click)="gs.showSelect = !gs.showSelect">
                Select For Download
            </button>
        </li>
        <li *ngIf="forPrint || gs.showSelect">
            <button class="t-menu-item" (click)="gs.selectAll()">
                Select All
            </button>
        </li>
        <li *ngIf="forPrint || gs.showSelect">
            <button class="t-menu-item" (click)="gs.selectAll(false)">
                Deselect All
            </button>
        </li>
        <li *ngIf="! forPrint && (gs.showSelect && (gs.imageGroup.get('imageSelection').value.includes(true)))">

            <div class="t-validation-wrap">
                <button class="t-menu-item" (click)="invalidi='is-invalid'" [ngClass]="invalidi"> Download
                    ({{dwonloadImageCt}})</button>

                <div class="t-validation-message" style="width:30vw;left:-13vw;font-size: 1.87em;top:+2vw">
                    <span>בחרת להוציא חומר הכולל מידע רפואי רגיש ממערכת מאובטחת , מרגע הורדה החומר אינו מוגן יותר אנא
                        הקפד שלא להשאירו בכונן או במיקום רשת נגיש לאנשים שאינם מורשים לצפות בחומר
                        <br>
                        <div style="display: flex; justify-content: space-between; margin-left: 1vw;margin-right: 1vw;">
                            <button (click)="gs.downloadImages();download=true;invalidi=''"
                                class="t-menu-item">אישור</button>
                            <button (click)="invalidi=''" class="t-menu-item">בטל</button>
                        </div>

                    </span>

                </div>
            </div>
        </li>
        <li *ngIf="! forPrint && gs.showSelect">
            <button class="t-menu-item" (click)="gs.showSelect = !gs.showSelect">
                Cancel
            </button>
        </li>
        </div>
        <div class="gallery-menu-end">
        <li *ngIf="! forPrint && ! gs.showSelect && this.ls.isCardio">
            <label style="margin-inline-end: 1em;">Gallary view</label>
            <select class="t-select t-field" style="background-color: aliceblue;" [ngModel]="view" (ngModelChange)="setView($event)">
                <option value="Timeline">Timeline</option>
                <option value="Groups">By Type</option>
            </select>
        </li>
        <li *ngIf="! forPrint">
            <button type="button" class="gallery-help-btn" (click)="openHelp('gallery')" matTooltip="Shortcuts (?)" aria-label="Shortcuts">?</button>
        </li>
        </div>
    </ul>
    <div class="h100 l-flex t-row t-boxMargin--spacebyPadding gallery-table" *ngIf="view =='Timeline'">
        <div class="l-fg1">
            <div class="h100 m-box l-fg1 gallery-still">
                <h2>
                    <i class="gallery-title-icon  icon-camera-still"></i>
                    Timeline
                </h2>
                <div class="scroller">

                    <div class="l-flex l-flex-w gallery-item-list" style="padding-bottom: 1.87em;">

                        <div class="gallery-item" *ngFor="let n of ' '.repeat(timelinect).split('');index as i">

                            <div class="gallery-item-in" style="width: 100%;" *ngIf="checkArray(gs.Timeline[i])">

                                <span (click)="open(i)" class="lb gallery-item-frame">

                                    <img [src]="_timeline[i].thumb" alt="" />

                                </span>
                                <textarea *ngIf="es.isGastro"
                                    style="background: none;border: none;margin: 3px;width: 95%;max-height: 1.5em;"
                                    [(ngModel)]="_timeline[i].text" (ngModelChange)="gs.saveText(i, _timeline[i].text)"
                                    [ngModelOptions]="{standalone: true}"></textarea>
                                <label *ngIf="forPrint || gs.showSelect" class="l-flex"
                                    style="justify-content: center;margin-bottom: 1%; margin-bottom: 2%;">
                                    <input type="checkbox" name="i" class="custom-check -sq" [value]="true"
                                        [formControlName]="i" />
                                    <i class="customInput-display"></i>
                                </label>

                            </div>
                            <ng-container *ngIf="! checkArray(gs.Timeline[i])">
                                <div class="h100 w100 gallery-videos">
                                    <div class="h100 frame">
                                        <div class="videoPlay">
                                            <div class="gallery-item" style="width: 100%;">
    
                                                <div class="gallery-item-in clip-tile" (click)="open(i)">

                                                    <span>

                                                        <img [src]="_timeline[i].thumb" alt="" draggable="false" />
                                                        <span>
                                                            <img src="../../assets/icons/play.svg" style="max-height: 2em ;padding-block-start: 0.5em;" draggable="false"/>
                                                        </span>

                                                    </span>

                                                </div>
    
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </ng-container>

                        </div>

                    </div>

                </div>
            </div>

        </div>

    </div>



    <div class="h100 l-flex t-row t-boxMargin--spacebyPadding gallery-table" *ngIf="view =='Groups'">

        <div class="l-fg1" *ngIf="show == 'all' || show == 'img' || forPrint || gs.showSelect">

            <div class="h100 m-box l-fg1 gallery-still" [formGroup]="gs.imageGroup">

                <h2>
                    <i class="gallery-title-icon icon-camera-still"></i>
                    Images
                </h2>

                <div class="scroller">

                    <div class="l-flex l-flex-w gallery-item-list" formArrayName="imageSelection"
                        style="padding-bottom: 1.87em;">

                        <div class="gallery-item" *ngFor="let n of ' '.repeat(imgct).split('');index as i">

                            <div class="gallery-item-in">

                                <span (click)="open(i)" class="lb gallery-item-frame">

                                    <img [src]="_albums[i].thumb" alt="" />

                                </span>
                                <textarea *ngIf="es.isGastro"
                                    style="background: none;border: none;margin: 3px;width: 95%;max-height: 1.5em;"
                                    [(ngModel)]="_albums[i].text" (ngModelChange)="gs.saveText(i, _albums[i].text)"
                                    [ngModelOptions]="{standalone: true}"></textarea>
                                <label *ngIf="forPrint || gs.showSelect" class="l-flex"
                                    style="justify-content: center;margin-bottom: 1%; margin-bottom: 2%;">
                                    <input type="checkbox" name="i" class="custom-check -sq" [value]="true"
                                        [formControlName]="i" />
                                    <i class="customInput-display"></i>
                                </label>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="h100 gallery-videos" *ngIf="! forPrint && ! gs.showSelect && show != 'img'" [ngClass]="show == 'all' ? (ls.isCardio ? 'w45' : '') : 'w100'">

            <div class="h100 m-box" *ngIf="show == 'all' || show == 'clip'">

                <h2>
                    <i class="gallery-title-icon icon-camera-video"></i>
                    Clips
                </h2>
                <p class="clip-hint" *ngIf="clipct > 0">Tick clips, or drag across them, to play up to {{ maxGrid }} together.</p>

                <div>
                    <!--class="scroller"-->

                    <div class="l-flex l-flex-w gallery-item-list gallery-videos-holder clip-area" #clipArea
                        (pointerdown)="dragStart($event, clipArea)" (pointermove)="dragMove($event)" (pointerup)="dragEnd($event)" (pointercancel)="dragEnd($event)">
                        <div class="clip-marquee" *ngIf="marquee" [style.left.px]="marquee.left" [style.top.px]="marquee.top" [style.width.px]="marquee.width" [style.height.px]="marquee.height"></div>
                        <div class="gallery-item" *ngFor="let n of ' '.repeat(clipct).split('');index as i" [ngClass]="ls.isCardio ? 'w33' :''">

                            <div class="gallery-item-in clip-tile" [attr.data-clip]="i" [ngClass]="(ls.isCardio ? 'cardioSizeImage' : '') + (isSelected(i) ? ' is-sel' : '')" (click)="openClip(i)">

                                <span>
                                    <img [src]="_clips[i].thumb" alt="" draggable="false" />
                                    <span>
                                        <img src="../../assets/icons/play.svg" style="max-height: 2em ;padding-block: 0.3em;" draggable="false"/>
                                    </span>
                                </span>
                                <button type="button" class="clip-tick" (click)="toggleClip(i, $event)" (pointerdown)="$event.stopPropagation()"
                                    [attr.aria-pressed]="isSelected(i)" [attr.aria-label]="'Select clip ' + (i + 1)"
                                    [matTooltip]="isSelected(i) ? 'Unselect' : 'Select to play in a grid'"></button>

                            </div>

                        </div>
                    </div>

                </div>

            </div>

            <div class="h100 gallery-videos w100" *ngIf="! forPrint && ! gs.showSelect && (show == 'all' || show == 'pdf')">

                <div class="h100 m-box">
    
                    <h2>
                        <i class="gallery-title-icon icon-pdf"></i>
                        Documents
                    </h2>
    
                    <div>
                        <!--class="scroller"-->
    
                        <div class="l-flex l-flex-w gallery-item-list gallery-videos-holder">
                            <div class="gallery-item w33" *ngFor="let n of ' '.repeat(pdfct).split('');index as i">
    
                                <div class="gallery-item-in cardioSizeImage">
    
                                    <span (click)="openPDF(i)">
                                        <img [src]="_pdfs[i].thumb" alt="" style="max-height: 9em;"/>
                                    </span>
                                    <button *ngIf="this.es.ExamType === 'Pulmonary functional assessment' || this.es.ExamType === 'Methacholine test'" style="height: fit-content" class="search-btn search-btn--newPatient ng-star-inserted" (click)="pdfDifTab(i)">Open In Different Tab</button>
    
                                </div>
    
                            </div>
                        </div>
    
                    </div>
    
                </div>
            </div>

            <div class="h100 m-box" *ngIf="! gs.showSelect && !ls.isCardio && (show == 'all' || show == 'clip')">

                <h2>
                    <i class="gallery-title-icon icon-camera-full"></i>
                    Full length recordings
                </h2>

                <div>
                    <!--class="scroller"-->

                    <div class="l-flex l-flex-w gallery-item-list gallery-videos-holder">
                        <div class="gallery-item" *ngFor="let n of ' '.repeat(fullct).split('');index as i">

                            <div class="gallery-item-in" (click)="openClip(i,true)">

                                <!-- <span (click)="openClip(i,true)" class="lb gallery-item-frame">

                                    <img alt="" />

                                </span> -->
                                <span >
                                    <img [src]="_fulls[i].thumb" alt="" />
                                    <span>
                                        <img src="../../assets/icons/play.svg" style="max-height: 2em ;padding-block: 0.3em;"/>
                                    </span>
                                </span>


                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>



    </div>
    <div class="clip-selbar" *ngIf="view == 'Groups' && selectedCount > 0 && ! forPrint && ! gs.showSelect" role="region" aria-label="Selected clips">
        <span class="clip-selbar__count">{{ selectedCount }} of {{ maxGrid }} clips selected<small *ngIf="selectLimitHit">, up to {{ maxGrid }} play together</small></span>
        <button type="button" class="clip-selbar__play" (click)="openGrid()" matTooltip="Play the selected clips side by side">
            <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2.5v11l9.5-5.5z" /></svg>Play in a grid
        </button>
        <button type="button" class="clip-selbar__clear" (click)="clearClips()" matTooltip="Unselect all clips">Clear</button>
    </div>
</section>
<!-- The viewer and the shortcuts, each rendered inside what it opens over: the shortcuts inside the
     viewer while it is open, both inside the grid while it is open. Something in full screen is on the
     browser's top layer, and anything outside it stays behind whatever its z-index. -->
<ng-template #help>
    <app-gallery-help *ngIf="helpFrom" [from]="helpFrom" [deletable]="deletable" [cardio]="ls.isCardio" (closed)="helpFrom = null"></app-gallery-help>
</ng-template>
<ng-template #overlays>
    <app-media-viewer *ngIf="viewerOpen" [items]="viewerItems" [index]="viewerIndex"
        [deletable]="deletable" [deleting]="deleting" [deleteFailed]="deleteFailed" (remove)="removeMedia($event)" (help)="openHelp('viewer')" (closed)="closeViewer()">
        <ng-container *ngTemplateOutlet="help"></ng-container>
    </app-media-viewer>
    <ng-container *ngIf="!viewerOpen">
        <ng-container *ngTemplateOutlet="help"></ng-container>
    </ng-container>
</ng-template>
<app-clip-grid *ngIf="gridOpen" [places]="gridPlaces" [all]="allClips" [max]="maxGrid" [covered]="viewerOpen"
    (open)="openFromGrid($event)" (toggle)="toggleInGrid($event)" (move)="moveInGrid($event)" (help)="openHelp('grid')" (closed)="gridOpen = false">
    <ng-container *ngTemplateOutlet="overlays"></ng-container>
</app-clip-grid>
<ng-container *ngIf="!gridOpen">
    <ng-container *ngTemplateOutlet="overlays"></ng-container>
</ng-container>